/**
 * Cliente API del reporte de Fondos de terceros (campañas muni/JJVV).
 * GET /tesoreria/fondos-terceros — recaudado vs transferido vs pendiente
 * (global) + desglose por categoría terceros.
 */
import { apiFetch } from './client';

export interface FondoTercerosCategoria {
  categoria_id: string;
  categoria_nombre: string;
  tipo: 'ingreso' | 'gasto';
  recaudado: number;
  transferido: number;
}

export interface ResumenFondosTerceros {
  total_recaudado: number;
  total_transferido: number;
  total_pendiente: number;
  categorias: FondoTercerosCategoria[];
}

export function getFondosTerceros(): Promise<ResumenFondosTerceros> {
  return apiFetch<ResumenFondosTerceros>('/tesoreria/fondos-terceros');
}
